import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Form } from '@formio/react';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import FormQualityCheck from '../../GuidanceWindow/FormQualityCheck';
import { APIURL } from '../../../../config';

//form_id, customer_id, task_id, onSubmit, isEditing
const FormRenderer = (props) => {
    const [json_schema, setJsonSchema] = useState({});
    const [data, setData] = useState({});
    const [errors, setErrors] = useState([]);
    const [saveError, setSaveError] = useState('');

    const isEditing = useRef(false);
    const cusForm = useRef(null);

    // The live submission, updated on every keystroke. Form.io's <Form> is
    // uncontrolled here -- `data` is a one-way seed set once from the server --
    // so without this the only copy of what the worker has typed lives inside
    // the Form.io instance, and the quality check has nothing to send.
    const draftRef = useRef(null);

    useEffect(() => {
        setJsonSchema(JSON.parse(props.json_schema));
    }, []);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            const response = await axios.get(APIURL + '/customer_form/task/' + props.task_id, { params: { formType: props.form_id } });
            if (response.data.length > 0) {
                isEditing.current = true;
                cusForm.current = response.data[0];
                setData(JSON.parse(response.data[0].data));
                props.onEdit && props.onEdit(response.data[0]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleSubmit = async (submission) => {
        setSaveError('');
        try {
            if (isEditing.current) {
                const response = await axios.put(APIURL + '/customer_form/' + cusForm.current.form_id, {
                    data: JSON.stringify(submission),
                    emp_id: props.user_id
                });
                if (response.data?.code !== 200) throw new Error(response.data?.message || 'Unable to save form');
                props?.onSubmit && props.onSubmit({ ...cusForm.current, data: JSON.stringify(submission) });
            } else {
                let form = {
                    customer_id: props.customer_id,
                    task_id: props.task_id,
                    data: JSON.stringify(submission),
                    form_type: props.form_id,
                    emp_id: props.user_id
                }
                const response = await axios.post(APIURL + '/customer_form', form);
                if (response.data?.code !== 200) throw new Error(response.data?.message || 'Unable to save form');
                props?.onSubmit && props.onSubmit(form);
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            setSaveError(error.response?.data?.message || error.message || 'Unable to save form. Please retry.');
        }
    }

    return (
        <Container sx={props.styles}>
            {saveError && <Alert severity="error">{saveError}</Alert>}
            <Form
                form={json_schema}
                submission={data}
                onChange={(submission) => {
                    // Form.io also fires this for its own internal redraws, which
                    // arrive without a data object -- keep the last real one.
                    if (submission && submission.data) draftRef.current = submission;
                }}
                onSubmit={handleSubmit}
                onError={(errors) => {
                    setErrors(errors);
                }}
                options={{
                    readOnly: props.readOnly,
                    hide: {
                        submit: props.readOnly,
                    }
                }}
            />

            {!props.readOnly && !!props.aiQualityCheck && (
                <FormQualityCheck
                    formType={props.form_id}
                    customerId={props.customer_id}
                    taskId={props.task_id}
                    empId={props.user_id}
                    getSubmission={() => draftRef.current || data}
                />
            )}
        </Container>
    )
};

export default FormRenderer;
